import httpClient from "@/api/httpClient.js";

const resource = "purses";

export function emptyPurse(bettingPoolAccountableEntityId) {
  return httpClient.put(`/${resource}/${bettingPoolAccountableEntityId}`, { accountable_entity_id: bettingPoolAccountableEntityId });
}
